<template>
    <div v-if="!loading" class="row justify-content-center" style="margin-left: -50px; margin-right: -50px;">
        <div class="col-8">
            <ul class="list-group list-group-flush">
                <template v-if="abonos.length > 0">
                    <template v-for="abono in abonos">
                        <AbonoDetalle :key="abono.id" :abono="abono"></AbonoDetalle>
                    </template>
                </template>
                <li class="list-group-item text-center" v-else>
                    <h3>
                        {{ $t('perfil.no_abonos', {abonos: teatro.texto_abonos}) }}
                    </h3>
                </li>
            </ul>
            <div class="d-flex justify-content-center" v-if="abonos">
                <PaginateComponent 
                    :current_page="pagination.current_page" 
                    :last_page="pagination.last_page"
                    v-on:change_page="setPage"
                />
            </div>
        </div>
    </div>
    <div style="padding: 50px;" v-else>
        <LoaderComponent></LoaderComponent>
    </div>
</template>

<script>
import AbonoDetalle from '@/components/frontend/perfil/AbonoDetalle';
import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";

export default {
    data() {
        return {
            abonos: null,
            loading: false,
            pagination: {},
            page: 1
        }
    },
    created() {
        this.getAbonos();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        getAbonos() {
            this.loading = true;

            const data = {
                filters: {
                    tid: this.configuracion.hash_teatro,
                    page: this.page
                },
                tid : this.configuracion.hash_teatro,
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.abonos'), data).then(res => {
                this.abonos = res.data.data;
                this.pagination = res.data.meta;
                this.loading = false;
            });
        },
        setPage(page) {
            this.page = page;
            this.getAbonos();
        },
    },
    components: {
        AbonoDetalle, PaginateComponent
    }
}
</script>
